import React, { useState } from "react";
import { CircleCheckIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { ui } from "../data/ui";
import { email as validateEmail } from "../utils/validation";
export function NewsletterForm() {
  const {
    t
  } = useLanguage();
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const err = validateEmail(value);
    if (err) {
      setError(t(err));
      return;
    }
    setError(null);
    setDone(true);
    setValue("");
  };
  if (done) {
    return <p role="status" className="flex items-center gap-2 font-semibold text-ink" data-id="element-293" data-mp="3nri1xxp0zh25">
        <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-294" data-mp="yzxmkie7tlwq" />
        {t(ui.footer.subscribed)}
      </p>;
  }
  return <form noValidate onSubmit={onSubmit} className="w-full max-w-md" data-id="element-295" data-mp="130ravcvkl2q5">
      <div className="flex gap-2" data-id="element-296" data-mp="h554d0b1tj1i">
        <label htmlFor="newsletter-email" className="sr-only" data-id="element-297" data-mp="h43towxy2ykb">
          {t(ui.footer.newsPlaceholder)}
        </label>
        <input id="newsletter-email" type="email" autoComplete="email" value={value} onChange={e => setValue(e.target.value)} placeholder={t(ui.footer.newsPlaceholder)} aria-invalid={Boolean(error)} aria-describedby={error ? "newsletter-error" : undefined} className="min-h-[44px] w-full rounded-sm border border-ink/30 bg-gold-light px-4 text-[15px] text-ink placeholder:text-ink/50 focus:border-ink focus:outline-none focus:ring-1 focus:ring-ink" data-id="element-298" data-mp="c6ljz4c3sfb9" />
        <button type="submit" className="btn-dark shrink-0" data-id="element-299" data-mp="3fn2f72v7orru">
          {t(ui.footer.subscribe)}
        </button>
      </div>
      {error && <p id="newsletter-error" role="alert" className="mt-1.5 text-xs font-semibold text-ink" data-id="element-300" data-mp="3bknv6fft3lyz">
          {error}
        </p>}
    </form>;
}